import { makeService } from './api';

const service = makeService('newsletter_subscriptions');

export default service;